<template lang="pug">
    v-dialog(v-model="value" max-width="580px" persistent)
      v-card.rounded-card(data-cy="registration-status-modal")
        v-card-title.pb-0
          v-layout(row justify-center)
            v-flex(xs12)
              h1.primary--text.text-xs-center.font-weight-thin.title-pad {{ titleText }}
        v-card-text.pt-2.pb-0
          v-layout(column align-center)
            v-flex(xs12)
              v-icon.my-3(size=60) $vuetify.icons.failed-status
          v-layout(row)
            v-flex(xs12)
              .xs12(v-for="line in content()" v-html="line")
          v-layout(column align-center)
            v-flex(xs12)
              v-btn.action-btn.text-xs-center(
                color="primary"
                @click="openTextingConsole()"
              ) Open Texting Console
        v-layout.mt-2(column align-center)
          v-flex.mt-2(xs12)
            v-btn.text-xs-center(color="primary" flat @click="$emit('close')") Close
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import { LdFeatures } from 'lion-vue';
  
  export default {
    name: 'LeadsPlusUnregisteredModal',
    props: {
      openDialog: false,
    },
    data() {
      return {
        checker: {},
      };
    },
    computed: {
      ...mapGetters('userInformation', ['hasAccessToFeature']),
      titleText() {
        return 'SMS Registration In Progress';
      },
      value: {
        get() {
          return this.openDialog;
        },
        set() {
          this.$emit('close');
        },
      },
    },
    methods: {
      openTextingConsole() {
        this.$emit('soft-close');
        this.$router.push('/communications/text/text-management');
      },
      content() {
        if (this.hasAccessToFeature(LdFeatures.BulkTexts)) {
          return [
              '<p><strong>Your SMS activity is limited to 1-to-1 communications with your Leads+ contacts until your registration is complete.</strong></p>',
              '<p>To ensure deliverability, we are registering your account with the US mobile carriers on your behalf. <a href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk" target="_blank">Learn more</a> about these requirements.</p>',
              '<p>When your registration is complete, you will have full access to all texting options on all your contacts - including 1 to 1 texts, Text2Sell for inbound leads, and more!</p>',
              '<p>To review your registration status, click the button below.</p>',
          ];
        }
        return [
            '<p><strong>Your SMS activity is limited to 1-to-1 communications with your Leads+ contacts until your registration is complete.</strong></p>',
            '<p>To ensure deliverability, we are registering your account with the US mobile carriers on your behalf. <a href="https://lonewolf.my.site.com/s/article/LD-FAQ-Texting-brand-registration-changes-June-2023-LionDesk" target="_blank">Learn more</a> about these requirements.</p>',
            '<p>When your registration is complete, you will have full access to all texting options on all your contacts - including 1 to 1 texts, Text2Sell for inbound leads, and more!</p>',
            `<p><span>To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.</p>`,
            '<p>To review your registration status, click the button below.</p>',
        ];
      },
    },
  };
  </script>
  
  <style scoped>
  .action-btn {
    text-transform: none;
  }
  
  .rounded-card {
    border-radius: 10px;
  }
  
  .title-pad {
    padding-left: 40px;
    padding-right: 40px;
    margin-top: -20px;
  }
  
  .v-card {
    padding-top: 5%;
    padding-left: 10px;
    padding-right: 10px;
  }
  </style>
  